/* eslint-disable import/prefer-default-export, no-shadow */
export enum Languages {
  EN = 'en',
  EN_US = 'en_US',
  DE = 'de',
  DE_DE = 'de_DE',
  IT = 'it',
  IT_IT = 'it_IT',
  FR = 'fr',
  FR_FR = 'fr_FR'
}

type LanguageListElement = {code: Languages, flag: string, name: string}

export const LANGUAGE_LIST: LanguageListElement[] = [
  { code: Languages.DE, flag: 'de', name: 'Deutsch' },
  { code: Languages.EN, flag: 'gb', name: 'English' },
  { code: Languages.FR, flag: 'fr', name: 'Français' },
  { code: Languages.IT, flag: 'it', name: 'Italiano' },
]

export const LANGUAGE_LIST_ADMIN: LanguageListElement[] = [
  { code: Languages.DE, flag: 'de', name: 'Deutsch' },
  { code: Languages.EN, flag: 'gb', name: 'English' },
]

/**
 * Returns the five-letter language code that is defined to be the corresponding code to the given
 * two-letter code. Example: de -> de_DE
 * @param lang The two-letter language code for which the five-letter code should be inferred
 */
export function inferCookieLanguage(lang: string) {
  switch (lang) {
    case Languages.EN_US:
      return Languages.EN_US;
    default:
      return lang;
  }
}

export const DEFAULT_LANGUAGE = Languages.EN;
export const TRANSLATION_LANGUAGES = [Languages.DE, Languages.FR, Languages.IT];
export const LANGUAGE_TRANSLATION_KEYS = {
  [Languages.EN]: 'libLanguage.localized.English',
  [Languages.EN_US]: 'libLanguage.localized.English',
  [Languages.DE]: 'libLanguage.localized.German',
  [Languages.DE_DE]: 'libLanguage.localized.German',
  [Languages.FR]: 'libLanguage.localized.French',
  [Languages.FR_FR]: 'libLanguage.localized.French',
  [Languages.IT]: 'libLanguage.localized.Italian',
  [Languages.IT_IT]: 'libLanguage.localized.Italian',
};

export class LanguagePayloads {
  // Helper function
  private static payloadFactory(lang: string, cookieLang = '', acceptedLang = '') {
    return { lang, cookieLang, acceptedLang };
  }

  /**
   * Generates a payload that is used in the language store (inside languages/translateTo)
   * If a language's cookie value or accepted language value differs from the 2-letter language code
   * it must be added into the switch statement as a special case
   * @param lang The 2-letter language code in lower case
   * @returns An object that contains the payload parameters for the language store
   */
  static get(lang: string) : any {
    const inferred = inferCookieLanguage(lang);
    return this.payloadFactory(lang, inferred, lang);
  }
}
